export default {
  header: {
    title: 'Payment',
    subTitle: 'Seat {{seat}}', 
  },
  tabs: {
    creditCard: 'Credit Card',
    opusCard: 'OPUS Card',
    cashOnBoard: 'Cash on Board',
    correspondance: 'Correspondance',
    free: 'Free',
    opusCardMensuel: 'Carte OPUS - Mensuel',
    opusCardPassage: 'Carte OPUS - Passage',
    cpoPassage: 'Carte a puce occasionnelle (CPO) - Passage',
    freeZeroToEleven: 'Free (0-11 Years)',
  },

  creditCard: {
    form: {
      fields: {
        cardNumber: {
          label: 'Card number',
          required: 'Card number is required',
        },
        cardHolderName: {
          label: 'Cardholder name',
          required: 'Cardholder name is required',
        },
        cardMonth: {
          label: 'Month',
          required: 'Month is required',
        },
        cardYear: {
          label: 'Year',
          required: 'Year is required',
        },
        cvv: {
          label: 'CVV',
          required: 'Card number is required',
        },
      },
    },
  },

  opusCard: {
    form: {
      fields: {
        cardNumber: {
          label: 'Opus Card number',
          required: 'Card number is required',
          min: 'OpusCardNumber must be at least {{length}} characters'
        },
      },
    },
  },

  cashOnBoard: {
    rateType: {
      ordinary: 'Ordinary',
      free0_5: 'Free (0-5 years)',
      free6_11: 'Free (6-11 years)', 
      free0_11: 'Free (0-11 years)',
    },
    form: {
      fields: {
        rateType: {
          label: 'Rate Type',
          required: 'Rate Type is required',
        },
      },
    },
  },
};